<div class="flex flex-col h-full w-full">
	<ng-container *ngIf="appointments$ | async as appointments">
		<div *ngIf="!appointments.length" class="flex grow place-items-center">
			<img class="pb-20" src="/assets/images/empty-states/appointments.svg" />
		</div>

		<div
			*ngFor="let matter of appointments"
			class="appointment"
			(click)="goToMatter(matter.id)"
			[testHook]="testHooks.GoToMatterDiv"
		>
			<div
				class="flex flex-col items-center justify-center border-r border-grey-veryLight"
			>
				<div>
					{{ matter?.appointment?.appointmentTime | date: 'shortTime' }}
				</div>
				<div class="text-sm">
					{{ matter?.appointment?.appointmentTime | date: 'mediumDate' }}
				</div>
			</div>
			<div class="flex flex-col overflow-hidden pl-2">
				<div class="font-bold truncate">
					{{ matter?.name }}
				</div>
				<div class="flex items-center mt-2">
					<atomic-matter-type-pill
						[fileType]="matter?.fileType"
						[testHook]="testHooks.MatterTypePill"
					></atomic-matter-type-pill>
					<app-icon
						[icon]="ICON.DOT"
						class="mx-3 text-grey-lighter dot"
						[testHook]="testHooks.DotIcon"
					></app-icon>
					<span class="text-sm font-bold">#{{ matter?.number }}</span>
				</div>

				<span class="truncate text-sm text-grey">
					{{ matter?.address | address }}
				</span>
			</div>
		</div>
	</ng-container>
</div>
